import { useEffect, useState } from 'react';

import { useErrorContext } from '../context/ErrorContext';
import { useSigningOrders } from './useSigningOrders';

const useSigning = () => {
    const [isSigning, setIsSigning] = useState(false);
    const [success, setIsSuccess] = useState(false);

    const { setError } = useErrorContext();

    const { invalidateQuery } = useSigningOrders();

    useEffect(() => {
        const signingOrderComplete = (e: MessageEvent) => {
            if (e.data.status && e.data.id) {
                switch (e.data.status) {
                    case 'completed':
                        setIsSuccess(true);
                        invalidateQuery();
                        setTimeout(() => {
                            setIsSigning(false);
                            setIsSuccess(false);
                        }, 2000);
                        break;
                    case 'canceled':
                        setIsSigning(false);
                        invalidateQuery();
                        break;
                    case 'error':
                        if (e.data.statusId === '32515') {
                            setError('signing_done');
                        } else if (e.data.statusId === '32516') {
                            setError('signing_rejected');
                        } else if (e.data.statusId === 'signrefnotfound') {
                            setError('signrefnotfound');
                        } else {
                            setError('generic_error');
                        }
                        invalidateQuery();
                        setIsSigning(false);
                        break;
                    default:
                }
            }
        };

        window.addEventListener('message', signingOrderComplete);
        return () => {
            window.removeEventListener('message', signingOrderComplete);
        };
    }, [setError, setIsSigning, invalidateQuery]);

    return { isSigning, setIsSigning, success, setIsSuccess };
};

export default useSigning;
